import {ModeOfTravel, SavingsOutlined} from "@mui/icons-material";
import {Typography} from "@mui/material";
import {useState} from "react";
import {useAuthState} from "react-firebase-hooks/auth";
import {useList} from "react-firebase-hooks/database";
import {useHistory} from "react-router-dom";
import {auth, createTripsHookQuery, TripModel} from "../firebase/index.js";
import {APXHideOnScrollFab} from "../reusables/APXHideOnScrollFab.jsx";
import {webappPaths} from "../reusables/js/AppRoutes.js";
import {red_900} from "../reusables/js/APXTheme.js";
import useHookForPlusUserCheckingAtMainPoint, {nonPlusLimits} from "../reusables/plus/APXPlus.js";
import {APXPlusRequiredAlert, APXPlusStatusAlert} from "../reusables/plus/APXPlusAlerts.jsx";
import AddNewTripBSL from "./AddNewTripBSL.jsx";
import TripLayout from "./TripLayout.jsx";


export default function TripMainFragment() {
	  const [user] = useAuthState(auth);
	  const uid = /*TRUTHY->*/ !!user && user?.uid;
	  
	  const [snapshots, loading, error] = useList(createTripsHookQuery(uid));
	  
	  const [openNewTripBSL, setOpenNewTripBSL] = useState(false);
	  const history = useHistory();
	  
	  const {isPlus} = useHookForPlusUserCheckingAtMainPoint(uid);
	  
	  return (
				 <>
						{
							  <APXPlusStatusAlert isPlus={isPlus}/>
						}
						{/*NOT->*/ !loading && snapshots.length === 0 &&
								  <Typography variant="h4" sx={{textAlign: "center", marginTop: 4}}>No trips found</Typography>
						}
						{/*NOT->*/ !loading && /*TRUTHY->*/ !!snapshots &&
								  snapshots.map((snapshot) => {
										 const trip: TripModel = TripModel.fromObject(snapshot.val());
										 return <TripLayout key={trip.tripKey} item={trip}/>;
								  })
						}
						<APXHideOnScrollFab icon={<SavingsOutlined/>} backgroundColour={"white"} colour={red_900}
												  sx={{position: "fixed", bottom: 80, right: 16}}
												  onClick={() => history.replace(webappPaths.estimation)}
						/>
						
						<APXHideOnScrollFab icon={<ModeOfTravel/>} backgroundColour={red_900} colour={"white"}
												  sx={{position: "fixed", bottom: 16, right: 16}}
												  onClick={() => setOpenNewTripBSL(true)}
						/>
						
						{openNewTripBSL ?
								  (
											 (isPlus)
											 ||
											 (/*NOT->*/ !isPlus && /*NOT->*/ !loading && /*TRUTHY->*/ !!snapshots && snapshots.length < nonPlusLimits.trip.numerical)
								  ) ?
											 <AddNewTripBSL uid={uid} onClose={() => setOpenNewTripBSL(false)} trip={null}/>
											 :
											 <APXPlusRequiredAlert/>
								  : null
						}
				 </>
	  );
}